<template>
  <div class="plugin-wrap rec-items layout" v-if="config && Array.isArray(config.nodes)">
    <div class="rec-item__image-wrap" v-for="(node, index) in config.nodes" :key="index">
      <Xink :action="node.action">
        <img :src="node.src" />
      </Xink>
    </div>
  </div>
</template>

<script>
import Xink from "@/components/Xink";

export default {
  components: { Xink },
  props: {
    config: { type: Object, required: true }
  }
}
</script>

<style lang="scss" scoped>
  .rec-items {
    display: flex;
    .rec-item__image-wrap { flex: 1; }
  }
</style>